import { DN500 } from '@atlaskit/theme/colors';
export var ArchiveSideBarWidth = 300;
export var itemStyle = {
  backgroundColor: "var(--ds-background-neutral-subtle, #101214)",
  fill: "var(--ds-icon-success, #101214)",
  color: "".concat("var(--ds-text, ".concat(DN500, ")")),
  ':hover': {
    backgroundColor: "var(--ds-background-neutral-subtle-hovered, #A1BDD914)",
    color: "".concat("var(--ds-text, ".concat(DN500, ")"))
  },
  ':active': {
    backgroundColor: "var(--ds-background-neutral-subtle-pressed, #A6C5E229)",
    color: "".concat("var(--ds-text, ".concat(DN500, ")"))
  }
};